<script>
import {mapState} from "vuex";
import i18n from "@/i18n";
import { VueTelInput } from 'vue-tel-input';
import {validateEmail} from "@/mixins/methods";
import {query} from "sinao-corejs";
import contacts from "@/store/contacts";
import onboardingPopoverMixin from "@/mixins/onboardingPopoverMixin";

export default {
  components: {
    VueTelInput
  },
  mixins: [onboardingPopoverMixin],
  props: {
    status: {
      type: Boolean,
      required: true,
      default: false
    }
  },
  data() {
    return {
      modalRefName: "ModalEditEstablishmentContact"
    };
  },
  computed: {
    ...mapState({
      appId: state => state.app.id,
      token: state => state.app.token,
      loadingContact: state => state.contacts.loadingContact,
      isThirdAccountGlobal: state => state.contacts.isThirdAccountGlobal
    }),
    estaContact: {
      get() {
        return this.$store.state.contacts.editableEstablishmentContact;
      },
      set(value) {
        this.$store.commit("editableEstablishmentContact", value);
      }
    },
    loadingContact: {
      get() {
        return this.$store.state.contacts.loadingContact;
      },
      set(value) {
        this.$store.commit("loadingContact", value);
      }
    },
    contactInfos: {
      get() {
        return this.isThirdAccount ? this.$store.state.contacts.thirdAccount : this.$store.state.contacts.contactInfos;
      },
      set(value) {
        this.isThirdAccount ? this.$store.commit("thirdAccount", value) : this.$store.commit("contactInfos", value);
      }
    },
  },
  mounted() {
  },
  methods: {
    closed() {
      this.onModalHidden();
      this.$store.commit('showEditEstablishmentContactModal', false)
    },
    async updateEstablishmentContact() {
      // prevent invalid email
      if (this.estaContact.email?.length && !validateEmail(this.estaContact.email)) {
        return this.$bvToast.toast(i18n.t('Email non valide'), {
          variant: "danger",
          solid: true
        });
      }
      // prevent empty email
      if (!this.estaContact.email?.length) {
        return this.$bvToast.toast(i18n.t('Email requis'), {
          variant: "danger",
          solid: true
        });
      }
      // update request
      this.loadingContact = true;
      /**
       * 2 cases :
       * if estaContact.id = 0 => create new contact
       * else => update existing contact
       */
      const _data = {...this.estaContact};
      // if this estaContact has no establishment, we need to create a new one
      const _establishment = !_data.establishment?.id
          ? await this.$store.dispatch("createEstablishment", this.isThirdAccountGlobal ? "thirdAccount" : "contactInfos")
          : this.estaContact.establishment;

      // case create new contact
      if (_data.id === 0) {
        delete (_data.establishment);
        try {
          const updated_establishment = await query({
            operationId: "app.contacts.establishments.update",
            token: this.token,
            params: {
              'appId': this.appId,
              'id': _establishment.id,
              'expand[0]': 'contacts'
            },
            data: {
              contacts: [
                  {
                    name: _data.name,
                    job: _data.job,
                    email: _data.email,
                    phone: _data.phone,
                    id: null
              }]
            }
          });

          this.$bvToast.toast(i18n.t('Success_contact_create'), {
            variant: "success",
            solid: true
          });

          this.$store.commit('updateContactInfosEstablishment', {
            target: this.isThirdAccountGlobal ? "thirdAccount" : "contactInfos",
            establishment: updated_establishment
          });
          // update contactInfos
          const contactIndex =  updated_establishment.contacts.findIndex(e => e.email === _data.email);
          if (contactIndex >= 0) {
            this.contactInfos.establishment_contact_id = updated_establishment.contacts[contactIndex].id;
            this.contactInfos.email = updated_establishment.contacts[contactIndex].email;
          }
          // close parent dialog
          this.$emit("close");
        } catch (error) {
          console.error(error);
        } finally {
          this.loadingContact = false;
        }
      } else {
        // update existing contact
        try {
          await query({
            operationId: "app.contacts.establishments.updateContact",
            token: this.token,
            params: {
              'appId': this.appId,
              'establishment_id': _data.establishment.id,
              'contact_id': _data.id
            },
            data: _data
          });

          this.$bvToast.toast(i18n.t('Success_contact_update'), {
            variant: "success",
            solid: true
          });

          this.$store.commit('updateContactInfosEstablishmentContact', {
            target: this.isThirdAccountGlobal ? "thirdAccount" : "contactInfos",
            contact: this.estaContact,
            establishment: this.estaContact.establishment
          });
          // update contactInfos
          this.contactInfos.establishment_contact_id = _data.id
          this.contactInfos.email = _data.email;
          // close parent dialog
          this.$emit("close");
        } catch (error) {
          console.error(error);
        } finally {
          this.loadingContact = false;
        }
      }
    }
  }
};
</script>

<template>
  <b-modal
      :ref="modalRefName"
      :visible="status"
      :ok-only="true"
      centered
      header-class="bg-modal-contact"
      :footer-class="{'bg-modal-contact': true}"
      size="sm"
      @close="closed"
      content-class="shadow"
      @shown="onModalShow"
  >
    <template #modal-header>
      <!-- Emulate built in modal header close button action -->
      <b-container style="max-width: 660px">
        <b-row>
          <b-col cols="11" class="pl-0">
            <b-container class="p-0">
              <b-row class="p-0">
                <b-col cols="1" style="margin-top: -0.1rem"><span class="d-none d-sm-block" style="font-size: 1rem"><b-icon icon="person" /></span></b-col>
                <b-col cols="11" class="pl-lg-0"><h5>{{ estaContact.id === 0 ? $t('Creer un destinataire') : $t('Mettre à jour un destinataire') }}</h5></b-col>
              </b-row>
            </b-container>
          </b-col>
          <b-col cols="1 text-right pr-0">
            <div class="close_icon icon_square text-center" @click="closed">
              <b-icon icon="x" font-scale="0.9" class="px-0" />
            </div>
          </b-col>
        </b-row>
      </b-container>
    </template>
    <template #modal-footer>
      <!-- Emulate built in modal header close button action -->
      <b-container>
        <b-row>
          <b-col class="text-right">
            <s-button
                type="border"
                style="width: auto"
                @click="closed"
            >
              {{ $t("Annuler") }}
            </s-button>
            <s-button
                type="success"
                style="width: auto"
                class="ml-2"
                :loading="loadingContact"
                :disabled="loadingContact"
                @click="updateEstablishmentContact"
            >
              {{ $t("Enregistrer") }}
            </s-button>
          </b-col>
        </b-row>
      </b-container>
    </template>

    <b-container>
      <b-row>
        <b-col cols="12">
          <b-container>
            <b-row>
              <b-col cols="6" style="padding-top: 0.35rem">
                {{ $t('Nom complet')}}
              </b-col>
              <b-col cols="6">
                <b-form-input
                    v-model="estaContact.name"
                    size="sm"
                    :placeholder="$t('Non renseigné')"
                    class="py-0"
                />
              </b-col>
            </b-row>
            <b-row class="mt-2">
              <b-col cols="6" style="padding-top: 0.35rem">
                {{ $t('Fonction / service')}}
              </b-col>
              <b-col cols="6">
                <b-form-input
                    v-model="estaContact.job"
                    size="sm"
                    :placeholder="$t('Non renseigné')"
                    class="py-0"
                />
              </b-col>
            </b-row>
            <b-row class="mt-2">
              <b-col cols="6" style="padding-top: 0.35rem">
                {{ $t('Téléphone')}}
              </b-col>
              <b-col cols="6">
                <vue-tel-input
                    v-model="estaContact.phone"
                    :input-options="{'placeholder': $t('Numéro de téléphone')}"
                />
              </b-col>
            </b-row>
            <b-row class="mt-2">
              <b-col cols="6" style="padding-top: 0.35rem">
                {{ $t('Email')}}*
              </b-col>
              <b-col cols="6">
                <b-form-input
                    v-model="estaContact.email"
                    size="sm"
                    :placeholder="$t('Non renseigné')"
                    class="py-0"
                />
              </b-col>
            </b-row>
          </b-container>
        </b-col>
      </b-row>
    </b-container>

  </b-modal>
</template>

<style scoped>

</style>